package com.neurobs.ccabserver.subjectsessionview.components.sessionrunview.components

import com.neurobs.ccab.{LogTestRun, TestRunDisplayData}
import com.neurobs.ccabserver.subjectsessionview.components.PropertyLabel
import com.neurobs.ccabserver.subjectsessionview.states.UserState
import com.neurobs.js.util.StringUtilities.dateTimeString
import com.neurobs.react.ReactUtil
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

@react
object LogTestRunTestRunView {
  case class Props(logTestRun: LogTestRun, testRun: TestRunDisplayData, enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    def logTestRun = props.logTestRun
    def testRun = props.testRun

    val userState = UserState.accessState
    def isSiteAdmin = userState.userData.isSiteAdmin

    def comments = logTestRun.comments.map(_.sortBy(_.time.instant.getEpochSecond).map(_.text)).getOrElse(List())
    def error = testRun.testRun.runError match {
      case Some(error) => Some(error)
      case None => logTestRun.error
    }

    def TestNameElement: ReactElement = testRun.testName.map(testName => PropertyLabel("Test", testName)).getOrElse(null)
    def StartTimeElement: ReactElement = PropertyLabel("Start time", dateTimeString(testRun.testRun.startTime))
    def ErrorElement: ReactElement = if (error.isDefined) RunErrorMessage(error.get) else null
    def LogfileElement: ReactElement = if (isSiteAdmin) LogfileLink(testRun.testRun.id) else null
    def CommentsElement: ReactElement = CommentsAccordion(comments)

    props.enclosingElement(
      Seq(
        TestNameElement,
        StartTimeElement,
        ErrorElement,
        LogfileElement,
        CommentsElement
      )
    )

  }
}
